import { IImportConfigurationEditSettings } from './../shared/import-configuration-edit-forms/import-configuration-edit-forms.component';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';
import { ImportConfigurationDTO, ImportConfigurationTransferType, FilterDTO, FilterOperator, ImportType, ImportConfigurationClientAccessType } from '../../../base/models/models.swagger.generated';
import { ImportConfigurationService } from './import-configuration.service';
import { AvpCustomAdaptor } from '../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { Component, OnInit, ViewChild } from '@angular/core';
import { RowSelectEventArgs, GridModule } from '@syncfusion/ej2-angular-grids';
import { CreateConfigurationUtil } from '../shared/create-configuration.util';
import { importConfigurationConfigurationRoute, importConfigurationCreateRoute } from 'src/app/core/routing/route-names';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { ClientAutocompleteComponent } from '../../../base/shared/client-autocomplete/client-autocomplete.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import * as pages from '../../../core/routing/page-names';
import { UrlHelper } from 'src/app/base/shared/url-helper';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { AuthService } from 'src/app/base/services/auth.service';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { ImportConfigurationTemplatesComponent, ImportTypeEnumFilter } from './import-configuration-templates/import-configuration-templates.component';
import { getNavisionTempalteIcon } from '../shared/import-configuration.util';
import { ImportConfigurationEditFormsComponent } from '../shared/import-configuration-edit-forms/import-configuration-edit-forms.component';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, of } from 'rxjs';
import { ImportConfigurationEditFormsCoordinatorService } from '../shared/import-configuration-edit-forms/import-configuration-edit-forms-coordinator.service';

@Component({
    selector: 'app-import-configuration',
    templateUrl: './import-configuration.component.html',
    styleUrls: ['./import-configuration.component.scss'],
    imports: [TitleBarComponent,
        ClientAutocompleteComponent,
        GridModule,
        ToolbarModule,
        QueryBuilderModule,
        ImportConfigurationEditFormsComponent,
        TranslateModule,
        CheckBoxModule,
        DialogModule,
        ImportConfigurationTemplatesComponent,
        CommonModule
    ]
})
export class ImportConfigurationComponent extends GridBaseComponent<any> implements OnInit {

  @ViewChild(ImportConfigurationEditFormsComponent)
  public configurationEditForm: ImportConfigurationEditFormsComponent;

  @ViewChild(DialogComponent)
  public templateDialog: DialogComponent;

  public configurationEditSettings: IImportConfigurationEditSettings = {
    importConfigurationRoute: importConfigurationConfigurationRoute,
    importConfigurationPageName: pages.importConfigurationsConfigurationPageName,
    supportResponseConfig: true
  };

  public TransferType = ImportConfigurationTransferType;
  public ImportType = ImportType;

  public checkBoxFilter = GridConstantsFactory.createCheckBoxFilter();

  //Selected template
  private selectedTemplateSubject = new BehaviorSubject<ImportConfigurationDTO | null>(null);
  public selectedTemplate$ = this.selectedTemplateSubject.asObservable();

  public get selectedTemplate(): ImportConfigurationDTO | null {
    return this.selectedTemplateSubject.value;
  }

  private set selectedTemplate(value: ImportConfigurationDTO | null) {
    this.selectedTemplateSubject.next(value);
  }
  //

  public get selectedClient(): ClientDTO {
    return this.importConfigurationService.selectedClient;
  }

  public get canEdit(): boolean {
    return this.authService.canUserEditImportConfigurations();
  }

  public get addAllowed(): boolean {
    return this.canEdit && this.selectedClient != null;
  }

  //Configuration
  private configurationSubject = new BehaviorSubject<ImportConfigurationDTO | null>(null);
  public configuration$ = this.configurationSubject.asObservable();

  public get configuration(): ImportConfigurationDTO | null {
    return this.configurationSubject.value;
  }

  public set configuration(value: ImportConfigurationDTO | null) {
    this.configurationSubject.next(value);
  }
  //

  private previousRowIndex: number;

  constructor(
    translateService: TranslateService,
    private router: Router,
    private importConfigurationService: ImportConfigurationService,
    private spinnerService: SpinnerService,
    private authService: AuthService,
    private formsCoordinationService: ImportConfigurationEditFormsCoordinatorService) {
    super(translateService, importConfigurationService);
  }

  public ngOnInit() {
    //Set initial filter when navigating over url
    var id = UrlHelper.getIdForSegment(pages.importConfigurationsConfigurationPageName, this.router);
    if (id != null && id != undefined) {
      this.importConfigurationService.setOneTimeFilter(new FilterDTO({ isComplex: false, field: 'id', operator: FilterOperator.Equal, value: id.toString() }));
    }

    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.importConfigurationService, this.spinnerService)
    });

    this.isActiveColumnName = 'configurationName';
    this.addIndexFindColumnName = 'configurationName';

    this.router.events.pipe(filter(event => event instanceof NavigationEnd && event.url.includes(importConfigurationConfigurationRoute || importConfigurationCreateRoute) && !event.url.includes(pages.importConfigurationsResponsePageName))).subscribe(() => {
      this.urlChanged();
    });
  }

  public urlChanged(): void {
    var id = UrlHelper.getIdForSegment(pages.importConfigurationsConfigurationPageName, this.router);
    if (this.router.url.startsWith(importConfigurationCreateRoute)) {
      //prevents creation when navigating over url because in this case the client is never set
      if (!this.authService.isUserAdminOrConfigurationAdmin() || (this.configuration == null && !this.selectedClient)) {
        this.router.navigate([importConfigurationConfigurationRoute]);
      }
      if (this.configuration == null) {
        this.configuration = CreateConfigurationUtil.createNewImportConfigurationDTO(this.selectedClient);
      }
    } else if (id != null) {
      this.importConfigurationService.getConfigurationById(+id).subscribe(data => {
        this.configuration = data;
      });
    } else {
      this.configuration = null;
      if (this.grid?.selectedRowIndex >= 0) {
        this.grid.selectRows([]);
      }
    }
  }

  public dataBound(): void {
    var id = UrlHelper.getIdForSegment(pages.importConfigurationsConfigurationPageName, this.router);
    if (id != null) {
      this.grid.selectRow(this.grid.getRowIndexByPrimaryKey(id));
    }
    this.urlChanged();
  }

  public onClientSelected(client: ClientDTO) {
    (this.configurationEditForm ? this.configurationEditForm.canCloseForm() : of(true)).subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }

      //Close configuration if client is changed
      this.onCancel();

      this.importConfigurationService.selectedClient = client;
      this.grid.refresh();
    });
  }

  public addConfiguration(): void {
    if (!this.selectedClient) {
      return;
    }
    if (!this.authService.isUserAdminOrConfigurationAdmin() && !this.selectedClient) {
      return;
    }
    (this.configurationEditForm ? this.configurationEditForm.canCloseForm() : of(true)).subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }
      //Create new Configuration
      this.configuration = CreateConfigurationUtil.createNewImportConfigurationDTO(this.selectedClient);
      this.router.navigate([importConfigurationCreateRoute]);
    });
  }

  public duplicateConfiguration(): void {
    if (!this.configuration) {
      return;
    }
    this.configurationEditForm.canCloseForm().subscribe((canClose: boolean) => {
      if (!canClose) {
        return;
      }
      this.configuration = this.configurationEditForm.duplicateActualConfiguration();
      this.grid.selectRows([]);
      this.router.navigate([importConfigurationCreateRoute]);
    });
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    (this.configurationEditForm ? this.configurationEditForm.canCloseForm() : of(true)).subscribe((canClose: boolean) => {
      if (!canClose) {
        this.grid.selectRows([this.previousRowIndex]);
        return;
      }
      const id = (args.data as ImportConfigurationDTO)?.id;
      if (!id) {
        return;
      }

      var importConfigId = UrlHelper.getIdForSegment(pages.importConfigurationsConfigurationPageName, this.router);
      if (importConfigId == id) {
        //dont redirect, url is already correct
        return;
      }

      this.router.navigate([importConfigurationConfigurationRoute + "/" + id + "/" + pages.configurationGeneralPageName]);
      this.previousRowIndex = this.grid?.selectedRowIndex;
    });
  }

  public onSaveConfiguration(configuration: ImportConfigurationDTO) {
    if (configuration.id === 0) {
      this.importConfigurationService.addRecord(configuration).subscribe({
        next: () => {
          this.configuration = null;
          this.grid.refresh();
          this.router.navigate([importConfigurationConfigurationRoute]);
        },
        error: () => {
          // Handled in service
        }
      });
    } else {
      this.importConfigurationService.updateRecord(configuration).subscribe({
        next: () => {
          this.configuration = null;
          this.grid.refresh();
          this.router.navigate([importConfigurationConfigurationRoute]);
        },
        error: () => {
          // Handled in service
        }
      });
    }
  }

  public onDelete(id: number) {
    this.importConfigurationService.deleteRecord(id).subscribe(() => {
      this.configuration = null;
      this.router.navigate([importConfigurationConfigurationRoute]);
      this.grid.refresh();
    });
  }

  public onCancel() {
    this.configuration = null;
    this.grid.selectRows([]);
    this.router.navigate([importConfigurationConfigurationRoute]);
  }

  public getTransferTypeName(transferType: number): string {
    return 'i18n.shared.import-config-transfer-types.' + ImportConfigurationTransferType[transferType];
  }

  public formatFilterImportType(importTypeEnumFilter: ImportTypeEnumFilter): string {
    if (!importTypeEnumFilter) {
      return '';
    }
    return this.translateService.instant('i18n.shared.import-types.' + ImportType[importTypeEnumFilter.importType]);
  }

  protected initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }

  public templateSelectedAndClose(args: any): void {
    this.onTemplateSelected(args);
    this.onTemplateOkClicked();
  }

  public onTemplateCancelClicked(): void {
    this.selectedTemplate = null;
    this.templateDialog.hide();
  }

  public onTemplateSelected(args) {
    this.importConfigurationService.getConfigurationById(args.id).subscribe(data => {
      data.clientAccessType = ImportConfigurationClientAccessType.Client;
      this.selectedTemplate = data;
    });
  }

  public onTemplateOkClicked(): void {
    this.configuration = this.formsCoordinationService.copyFromTemplate(this.selectedTemplate);
    this.configuration.client = this.selectedClient;
    // STARGATE-254 requested new configuration should be inactive
    this.configuration.isActive = false;

    this.grid.selectRows([]);
    this.router.navigate([importConfigurationCreateRoute]);
    this.selectedTemplate = null;
    this.templateDialog.hide();
  }

  public openTemplateDialog(): void {
    this.selectedTemplate = null;
    this.templateDialog.show();
  }

  public getNavisionTempalteIcon(data: ImportConfigurationDTO): string {
    return getNavisionTempalteIcon(data);
  }

  public getClientName(data: ImportConfigurationDTO): string {
    if (data.client) {
      return data.client?.name + ' (' + (data.client?.customerNumber ?? data.client?.vendorNumber) + ')';
    }
    return '';
  }
}
